export default {
    'normal': {
        fontFamily: 'webfont-regular',
    },
    'bold': {
        fontFamily: 'webfont-bold',
        // fontWeight: 700,
        // fontStyle: 'normal',
    },
    'medium': {
        fontFamily: 'webfont-medium',
        // fontWeight: 500,
        // fontStyle: 'normal',
    },
    'mediumItalic': {
        fontFamily: 'webfont-medium-italic',
        // fontWeight: 500,
        // fontStyle: 'italic',
    },
    'light': {
        fontFamily: 'webfont-light',
        // fontWeight: 300,
        // fontStyle: 'normal',
    },
};


// WEBPACK FOOTER //
// ./src/constants/fonts.ts